import { Constants } from "../const/result";

export function guageChange(type) {
  let color = "silver";
  if (type === "download") {
    color = Constants.DOWNLOAD_COLOR;
  } else if (type === "upload") {
    color = Constants.UPLOAD_COLOR;
  }
  return {
    yAxis: {
      minColor: color,
      maxColor: color,
    },
    plotOptions: {
      solidgauge: {
        dataLabels: {
          format:
            '<div style="text-align:center;width:90px;"><span style="font-size:40px;color:' +
            color +
            '">{y}</span><br/><span style="font-size:14px;color:silver">Mbps</span></div>',
        },
      },
    },
    series: [
      {
        data: [0],
      },
    ],
  };
}

export function gaugeOptions(type) {
  const color = "silver";
  return {
    chart: {
      type: "solidgauge",
      backgroundColor: "#151414",
      height: "250px",
    },
    title: null,
    credits: {
      enabled: false,
    },
    pane: {
      center: ["50%", "60%"],
      size: "100%",
      startAngle: -135,
      endAngle: 135,
      background: {
        backgroundColor: "#2B3346",
        borderWidth: 2,
        borderColor: "#4377B5",
        innerRadius: "95%",
        outerRadius: "110%",
        shape: "arc",
      },
    },
    tooltip: {
      enabled: false,
    },
    yAxis: {
      min: 0,
      max: Constants.MAX_SPEED,
      minColor: color,
      maxColor: color,
      lineWidth: 0,
      minorTickInterval: null,
      tickPixelInterval: 50,
      tickWidth: 0,
      labels: {
        x: -2,
        style: {
          color: "#ccc",
          fontSize: "14px",
        },
      },
    },
    plotOptions: {
      solidgauge: {
        innerRadius: "95%",
        radius: "110%",
        dataLabels: {
          y: -45,
          borderWidth: 0,
          useHTML: true,
          format:
            '<div style="text-align:center;width:90px;"><span style="font-size:40px;color:' +
            color +
            '">{y}</span><br/><span style="font-size:14px;color:silver">Mbps</span></div>',
        },
      },
    },
    series: [
      {
        data: [0],
      },
    ],
  };
}

export function splineOptions(options, from = "h5") {
  return {
    chart: {
      type: "spline",
      backgroundColor: options.backgroundColor,
      height: "100px",
      spacingTop: 0,
      spacingBottom: 20,
      animation: {
        duration: 50,
      },
    },
    title: null,
    credits: {
      enabled: false,
    },
    xAxis: {
      visible: false,
      max:
        from === "h5"
          ? Constants.LOAD_TIME / Constants.INTERVAL_TIME -
            Constants.WAITING_TIME / Constants.INTERVAL_TIME
          : null,
    },
    tooltip: {
      enabled: false,
    },
    yAxis: {
      visible: false,
      minPadding: 0,
      maxPadding: 0,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      spline: {
        marker: {
          radius: 0,
        },
      },
    },
    series: [],
  };
}
